export enum UserRelation {
	PATIENT_DOCTOR = 1,
	MEDDI_DIABETES = 3,
	MEDDI_BABY = 4,
	MOU = 8,
	WORKPLACE_MEMBER = 1,
	WORKPLACE = 9,
}
